import React, {Component} from 'react';
import './App.css';
import {apiRequests} from "./hooks/apiRequests";
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import Page from "./components/Page";
import NotificationMessage from "./components/NotificationMessage";
import {useTelegram} from "./hooks/useTelegram";
import {bindActionCreators} from "redux";
import {changeUserData} from "./actions";
import {connect} from "react-redux";
import Preloader from "./components/Preloader";

import {Buffer} from "buffer";

Buffer.from("anything", "base64");
window.Buffer = window.Buffer || require("buffer").Buffer;

const PreloadFonts = () => (
    <>
        <link rel="preload" href="https://tgapp.investorium.org/fonts/MontExtraLight/MontExtraLight.woff" as="font" type="font/woff" crossorigin="anonymous" />
        <link rel="preload" href="https://tgapp.investorium.org/fonts/MontLight/MontLight.woff" as="font" type="font/woff" crossorigin="anonymous" />
        <link rel="preload" href="https://tgapp.investorium.org/fonts/MontRegular/MontRegular.woff" as="font" type="font/woff" crossorigin="anonymous" />
        <link rel="preload" href="https://tgapp.investorium.org/fonts/MontSemiBold/MontSemiBold.woff" as="font" type="font/woff" crossorigin="anonymous" />
        <link rel="preload" href="https://tgapp.investorium.org/fonts/MontBold/MontBold.woff" as="font" type="font/woff" crossorigin="anonymous" />
    </>
);


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tg: null,           // Для хранения объекта Telegram
            loading: true,      // Для отслеживания состояния загрузки
            userAuthenticated: false, // Для отслеживания состояния аутентификации
            error: false,

            viewportStableHeight: null
        };
    }

    PreloadFonts () {



        // Динамически добавляем теги <link> для предзагрузки шрифтов
        const link1 = document.createElement('link');
        link1.rel = 'preload';
        link1.href = 'https://tgapp.investorium.org/fonts/MontExtraLight/MontExtraLight.woff';
        link1.as = 'font';
        link1.type = 'font/woff';
        link1.crossOrigin = 'anonymous';
        document.head.appendChild(link1);

        const link2 = document.createElement('link');
        link2.rel = 'preload';
        link2.href = 'https://tgapp.investorium.org/fonts/MontLight/MontLight.woff';
        link2.as = 'font';
        link2.type = 'font/woff';
        link2.crossOrigin = 'anonymous';
        document.head.appendChild(link2);

        const link3 = document.createElement('link');
        link3.rel = 'preload';
        link3.href = 'https://tgapp.investorium.org/fonts/MontRegular/MontRegular.woff';
        link3.as = 'font';
        link3.type = 'font/woff';
        link3.crossOrigin = 'anonymous';
        document.head.appendChild(link3);

        const link4 = document.createElement('link');
        link4.rel = 'preload';
        link4.href = 'https://tgapp.investorium.org/fonts/MontSemiBold/MontSemiBold.woff';
        link4.as = 'font';
        link4.type = 'font/woff';
        link4.crossOrigin = 'anonymous';
        document.head.appendChild(link4);

        const link5 = document.createElement('link');
        link5.rel = 'preload';
        link5.href = 'https://tgapp.investorium.org/fonts/MontBold/MontBold.woff';
        link5.as = 'font';
        link5.type = 'font/woff';
        link5.crossOrigin = 'anonymous';
        document.head.appendChild(link5);
    }

    PreloadImage(url, type) {
        // Динамически добавляем теги <link> для предзагрузки изображений
        const link = document.createElement('link');
        link.rel = 'preload';
        link.href = url;
        link.as = 'image';
        link.type = 'image/'+type;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
    }


    handleViewportChangedDeactivated = () => {
        if (this.state.viewportStableHeight === null) {
            this.state.viewportStableHeight = window.Telegram.WebApp.viewportStableHeight;
        }
    };

    handleViewportChanged = () => {
        if (this.state.viewportStableHeight !== null && this.state.viewportStableHeight > 0) {
            document.documentElement.style.setProperty('--tg-viewport-stable-height', this.state.viewportStableHeight+'px');
            document.body.style.setProperty('--tg-viewport-stable-height', this.state.viewportStableHeight+'px');
        }
    };


    componentDidMount() {



        // Инициализация Telegram Web App SDK
        const {onToggleButton, onExpand, onDisableVerticalSwipes, tg,
            onSetHeaderColor, onSetBottomBarColor, onReady} = useTelegram();
        this.setState({ tg });

        this.PreloadFonts();

        onExpand(); // Открытие в полноэкранный режим
        onDisableVerticalSwipes(); // Отключаем свайпы

        // Настройки цвета
        onSetHeaderColor('#00ff00');
        onSetBottomBarColor('#ff0000');
        onReady(); // Подготовка

        // Запрос на аутентификацию
        const { reqAuth } = apiRequests();
        const { changeUserData } = this.props;

        reqAuth(tg.initData)
            .then(result => {
                // Если аутентификация успешна, обновляем состояние
                this.props.changeUserData(result);
                this.PreloadImage(this.props.userData.photo_url);
                this.setState({ userAuthenticated: true, loading: false });
            })
            .catch(err => {
                console.error('Ошибка аутентификации:', err);
                this.setState({ loading: false, error: err });
            });/**/


        //window.Buffer = Buffer; // Устанавливаем полифилл Buffer в глобальную область видимости!!!!!!!!!!
        window.Telegram.WebApp.onEvent('deactivated', this.handleViewportChangedDeactivated);
        window.Telegram.WebApp.onEvent('activated', this.handleViewportChanged);
    }

    render() {
        const { loading, userAuthenticated, error } = this.state;

        // Пока идет загрузка, показываем сообщение
        if (loading) {
            return (
                <Preloader />
            );
        }

        // Если аутентификация не прошла, показываем ошибку
        if (!userAuthenticated) {
            console.log(error.message);
            if(error.message === '403') {
                return (
                    <div className={"wrapper"}>
                        <div className={"preloader-error noselect"}>
                            <span className={"preloader-error-text"}>
                                Authorization error.<br/>Please log in to the app<br/>using Telegram.
                            </span>
                        </div>
                    </div>
                );
            } else if (error.message === '404') {
                return (
                    <div className={"wrapper"}>
                        <div className={"preloader-error noselect"}>
                            <span className={"preloader-error-text"}>
                                Server not found.<br/>The requested resource<br/>could not be reached.
                            </span>
                        </div>
                    </div>
                );
            } else {
                return(
                <div className={"wrapper"}>
                    <div className={"preloader-error noselect"}>
                            <span className={"preloader-error-text"}>
                                Something went wrong.<br/>Refresh the app page.
                            </span>
                    </div>
                </div>
            );
            }

        }
        // Если аутентификация успешна, показываем основное приложение
        return (
            <div>
                <div className={"wrapper"}>
                    <Header/>
                    <Page/>
                    <NotificationMessage/>
                </div>
                <Navbar/>
            </div>
        );
    }
}

const mapStateToProps = ({userData}) => {
    return {userData};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        changeUserData: changeUserData
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(App);